import React from 'react';

import { Action } from '@bypasslane/clover--web-lib-sprout-action';
import { FormGroup } from '@bypasslane/clover--web-lib-sprout-form-group';
import { SecretTextField } from '@bypasslane/clover--web-lib-sprout-secret-text-field';
import { TextField } from '@bypasslane/clover--web-lib-sprout-text-field';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

export default function LoginForm({
  register,
  handleSubmit,
  isSignInLoading,
  onSubmit,
  error,
  errors
}) {
  return (
    <div className="w-full md:w-[30rem] max-w-full">
      <FormGroup errorText={error} legend="Please sign in" isLegendVisible={false}>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="login__field">
            <TextField
              className="login__field"
              label="Email address"
              {...register('email', { required: 'Email is required' })}
              errorText={errors?.email?.message}
            />
          </div>

          <div className="login__field">
            <SecretTextField
              label="Password"
              {...register('password', { required: 'Password is required' })}
              errorText={errors?.password?.message}
            />
          </div>

          <div>
            <Action fullwidth variant="primary" type="submit" loading={isSignInLoading}>
              Sign in
            </Action>
          </div>
        </form>
      </FormGroup>
      <div className="my-4">
        <RouterLink
          to={`/forgot-password`}
          className="font-semibold text-gray-600 hover:text-gray-500"
        >
          Forgot your password?
        </RouterLink>
      </div>
    </div>
  );
}
LoginForm.propTypes = {
  register: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  isSignInLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  passwordChangeSuccess: PropTypes.bool,
  errors: PropTypes.shape({
    password: PropTypes.shape({
      message: PropTypes.string
    }),
    email: PropTypes.shape({
      message: PropTypes.string
    })
  })
};
LoginForm.displayName = 'LoginForm';
